import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../Forms/BorderedFormGrid";
import { useResolveGeoCoordinates } from "../../GoogleMaps/useResolveGeoCoordinates";
import { CountrySelect } from "../../Locations/CountrySelect";
import Odc from "../Odc";
import { OdcTypeChangedProps } from "./OdcFormProps";
import { GeoCoordinatesAddressTextField } from "../../Supplier/Form/GeoCoordinatesAddressTextField";
import { TextFieldInput } from "../../Forms/TextFieldInput";
import { isTruthyAndNotEmpty } from "../../Utils/strings";
import { RhfEnumSelect } from "../../Forms/RhfEnumSelect";
import { odcTypeAsString } from "../OdcType";
import { MdmFormProps } from "../../Forms/MdmFormProps";

export const OdcDataForm = ({
  disabledFields,
  onOdcTypeChanged,
}: MdmFormProps & OdcTypeChangedProps) => {
  const { control, getValues, setValue } = useFormContext<Odc>();

  const { resolveGeoCoordinatesIfAddressIsComplete } = useResolveGeoCoordinates<Odc>(
    "Street",
    "Zipcode",
    "City",
    "Latitude",
    "Longitude"
  );

  return (
    <BorderedFormGrid>
      <Grid item xs={4}>
        <TextFieldInput name="Name" control={control} required disabledFields={disabledFields} />
      </Grid>
      <Grid item xs={4}>
        <GeoCoordinatesAddressTextField
          name="City"
          control={control}
          disabledFields={disabledFields}
          triggerGeoCoordinatesCalculation={(fallbackGeoCoordinates) => {
            setValue("Latitude", fallbackGeoCoordinates.latitude);
            setValue("Longitude", fallbackGeoCoordinates.longitude);
            if (isTruthyAndNotEmpty(getValues("City"))) resolveGeoCoordinatesIfAddressIsComplete();
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <RhfEnumSelect
          name="Type"
          control={control}
          label="Location Type"
          onSelectionChange={onOdcTypeChanged}
          options={odcTypeAsString}
          disabledFields={disabledFields}
        />
      </Grid>
      <Grid item xs={4}>
        <TextFieldInput name="Details" control={control} disabledFields={disabledFields} />
      </Grid>
      <Grid item xs={4}>
        <TextFieldInput name="Region" control={control} disabledFields={disabledFields} />
      </Grid>
      {/* Placeholder */}
      <Grid item xs={4} />
      <Grid item xs={4}>
        <GeoCoordinatesAddressTextField
          name="Street"
          control={control}
          disabledFields={disabledFields}
          triggerGeoCoordinatesCalculation={(fallbackGeoCoordinates) => {
            setValue("Latitude", fallbackGeoCoordinates.latitude);
            setValue("Longitude", fallbackGeoCoordinates.longitude);
            if (isTruthyAndNotEmpty(getValues("Street")))
              resolveGeoCoordinatesIfAddressIsComplete();
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <CountrySelect control={control} name="CountryId" required />
      </Grid>
      {/* Placeholder */}
      <Grid item xs={4} />
      <Grid item xs={4}>
        <GeoCoordinatesAddressTextField
          name="Zipcode"
          control={control}
          label="Postcode"
          disabledFields={disabledFields}
          triggerGeoCoordinatesCalculation={(fallbackGeoCoordinates) => {
            setValue("Latitude", fallbackGeoCoordinates.latitude);
            setValue("Longitude", fallbackGeoCoordinates.longitude);
            if (isTruthyAndNotEmpty(getValues("Zipcode")))
              resolveGeoCoordinatesIfAddressIsComplete();
          }}
        />
      </Grid>
      {/* Placeholder */}
      <Grid item xs={8} />
      <Grid item xs={4}>
        <TextFieldInput
          name="ZipArea"
          control={control}
          label="Postcode Area"
          disabledFields={disabledFields}
        />
      </Grid>
      {/* Placeholder */}
      <Grid item xs={8} />
    </BorderedFormGrid>
  );
};
